export default class User {
  id = ''
  name = ''
  mobile = ''
  email = ''
  photo = ''
  active = ''
  token = ''
  shared = ''
  userId = ''
  selected = false
  loadJson = function (jsonData) {
    this.id = jsonData.id
    this.name = jsonData.name
    this.mobile = jsonData.mobile
    this.email = jsonData.email
    this.photo = jsonData.photo
    this.active = jsonData.active
    this.token = jsonData.token
    this.shared = jsonData.shared
    this.userId = jsonData.userId
  }
}



// WEBPACK FOOTER //
// ./src/common/model/User.js